module.exports = __webpack_public_path__ + "static/media/desktop.99606f3b.svg";